import style from "../style/screens/PublicPage.module.css";

const deleteRequestHref = [
    "mailto:support@innaim.com",
    "?subject=",
    encodeURIComponent("[모두해요] 계정 삭제 요청"),
    "&body=",
    encodeURIComponent(
        [
            "모두해요 계정 삭제를 요청합니다.",
            "",
            "가입한 휴대전화번호:",
            "가입자 이름:",
            "",
            "※ 본인확인을 위해 고객지원에서 추가 정보를 요청할 수 있습니다.",
        ].join("\n"),
    ),
].join("");

const DeleteAccount = () => (
    <main className={style["page"]}>
        <section className={style["card"]}>
            <p className={style["eyebrow"]}>모두해요 계정 삭제</p>
            <h1>앱 없이도 계정 삭제를 요청할 수 있습니다</h1>
            <p>
                앱을 이용할 수 있다면 <b>계정 → 계정 탈퇴하기</b>에서 직접 처리할 수 있습니다.
                앱에 로그인할 수 없는 경우 아래 버튼으로 고객지원에 삭제를 요청해주세요.
            </p>

            <h2>처리 절차</h2>
            <ol>
                <li>가입한 휴대전화번호와 이름을 포함해 삭제 요청 이메일을 보냅니다.</li>
                <li>고객지원이 계정 보호를 위해 휴대전화 본인확인 등 추가 확인을 안내합니다.</li>
                <li>본인확인이 끝나면 계정 삭제 및 관련 데이터 처리를 완료하고 결과를 회신합니다.</li>
            </ol>

            <h2>삭제·익명화되는 정보</h2>
            <ul>
                <li>Firebase 로그인 계정</li>
                <li>이름, 휴대전화번호, 생년월일, 즐겨찾기 등 회원 정보</li>
                <li>미완료 포인트 사용 신청</li>
                <li>포인트·수거 키오스크 이용 기록의 회원 식별자</li>
            </ul>
            <p>
                포인트·수거 키오스크 이용 기록은 정산과 서비스 통계를 위해 회원을 식별할 수 없는 형태로
                보관될 수 있습니다. 법령상 보관 의무가 있는 정보는 해당 기간 이후 파기합니다.
            </p>

            <a className={style["primary-link"]} href={deleteRequestHref}>
                이메일로 삭제 요청하기
            </a>
            <p className={style["help"]}>
                문의: <a href="mailto:support@innaim.com">support@innaim.com</a>
            </p>
            <nav className={style["links"]} aria-label="정책 링크">
                <a href="/privacy-policy">개인정보처리방침</a>
                <a href="/support">고객지원</a>
            </nav>
        </section>
    </main>
);

export default DeleteAccount;
